import React from 'react'

const Testimonial = () => {
  return (
    <div id='testimonial'>
        <h2>Testimonial</h2>
        <section>
            <TestimonialCard name={"Codename Origin"} feedback={"Best website developer and good behavior also budget friendly 😅"}/>
            <TestimonialCard name={"Atharva Inamdar"} feedback={"We re-did our website twice in a 12 month period. There was no comparison between the first company and Pavan. Professional, Creative, Attentive to Detail, Excellent Communication"}/>
            <TestimonialCard name={"Pranav Kalaskar"} feedback={
                " Very happy with our new website! It looks professional and very easy to navigate. Our experience with Pavan has been great."
            }/>
        </section>
    </div>
  )
}

const TestimonialCard =(
    {
        name,
        feedback
    }
)=>(
    <article>
        <img src="https://cdn-icons-png.flaticon.com/512/149/149071.png" alt="User" />
        <h4>{name}</h4>
        <p>{feedback}</p>
    </article>
)

export default Testimonial